import api, { API_ENDPOINTS } from './api';
// import { CourseCode, CodeType, ApiResponse, CourseCodeGenerationRequest, CourseCodeRegistrationRequest } from '../types';

export interface CourseCodeService {
  generateCourseCode: (request: CourseCodeGenerationRequest) => Promise<CourseCode>;
  registerWithCode: (request: CourseCodeRegistrationRequest) => Promise<ApiResponse<any>>;
  validateCode: (code: string) => Promise<CourseCode>;
  getUserCourseCodes: (userId: number) => Promise<CourseCode[]>;
}

class CourseCodeServiceImpl implements CourseCodeService {
  
  async generateCourseCode(request: CourseCodeGenerationRequest): Promise<CourseCode> {
    try {
      const response = await api.post(API_ENDPOINTS.COURSE_CODES.GENERATE, request);
      return response.data.data;
    } catch (error: any) {
      console.error('Error generating course code:', error);
      throw new Error(error.response?.data?.message || 'Failed to generate course code');
    }
  }

  async registerWithCode(request: CourseCodeRegistrationRequest): Promise<ApiResponse<any>> {
    try {
      const response = await api.post(API_ENDPOINTS.COURSE_CODES.REGISTER, request);
      return response.data;
    } catch (error: any) {
      console.error('Error registering with course code:', error);
      throw new Error(error.response?.data?.message || 'Failed to register with course code');
    }
  }

  async validateCode(code: string): Promise<CourseCode> {
    try {
      const response = await api.get(`${API_ENDPOINTS.COURSE_CODES.VALIDATE}/${code}`);
      return response.data.data;
    } catch (error: any) {
      console.error('Error validating course code:', error);
      throw new Error(error.response?.data?.message || 'Invalid course code');
    }
  }

  async getUserCourseCodes(userId: number): Promise<CourseCode[]> {
    try {
      const response = await api.get(`${API_ENDPOINTS.COURSE_CODES.USER_CODES}/${userId}`);
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching user course codes:', error);
      return [];
    }
  }
}

export const courseCodeService = new CourseCodeServiceImpl();
export default courseCodeService;
